/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_StreetInputs */

const en_orders_no_street = /** @type {(inputs: Orders_No_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No street`)
};

const es_orders_no_street = /** @type {(inputs: Orders_No_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin calle`)
};

/**
* | output |
* | --- |
* | "No street" |
*
* @param {Orders_No_StreetInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_street = /** @type {((inputs?: Orders_No_StreetInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_StreetInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_street(inputs)
	return es_orders_no_street(inputs)
});